import { windowForDate } from "@1-now/booking-core";

// The one sentence for a closed day, so every picker says it the same way (1NOW-3015).
export const CLOSED_DAY_TOAST = "We're closed on the selected date. Please choose another day.";

/**
 * What to tell a renter whose date has no slot left.
 *
 * The hours quoted are the ones the location keeps ON THAT DATE. The location's single
 * operational_start_time / operational_end_time pair is only one weekday's on a branch with
 * weekly_hours, and quoting it told a renter who picked a closed Sunday that the branch
 * opens 9 to 7 (1NOW-3015).
 *
 * `location` is the one the failed slot check read, so the message never contradicts it.
 */
export const noSlotMessage = (
  location: Parameters<typeof windowForDate>[0],
  date: Date | null | undefined,
  formatTime: (time: string) => string,
): string => {
  const dayWindow = windowForDate(location, date);
  if (dayWindow === null) return CLOSED_DAY_TOAST;
  return dayWindow.start && dayWindow.end
    ? `No available time slot on the selected date. Operational hours: ${formatTime(dayWindow.start)} – ${formatTime(dayWindow.end)}.`
    : "No available time slot on the selected date.";
};
